<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">accessibility_new</span>
      <p>
        Registra los hallazgos clínicos por órgano y sistema: documenta
        observaciones libres, selecciona hallazgos patológicos del catálogo
        y usa el dictado por voz para agilizar el ingreso de información.
      </p>
    </div>

    <!-- Cómo funciona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Cómo funciona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in flujo" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Hallazgos patológicos -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">fact_check</span>
        Hallazgos patológicos
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in hallazgos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Dictado por voz -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">mic</span>
        Dictado por voz
      </h3>
      <div class="help-voz">
        <div class="help-voz-item">
          <span class="material-symbols-outlined" style="color:orangered;font-size:28px">mic_off</span>
          <p class="help-card-desc">Micrófono <strong>inactivo</strong>. Pulsa para iniciar el dictado en el campo Observación.</p>
        </div>
        <div class="help-voz-item">
          <span class="material-symbols-outlined" style="color:green;font-size:28px">mic</span>
          <p class="help-card-desc">Micrófono <strong>activo</strong>. El sistema transcribe tu voz en tiempo real. Pulsa para detener.</p>
        </div>
        <div class="help-voz-item">
          <span class="material-symbols-outlined" style="font-size:28px;color:#555">delete_forever</span>
          <p class="help-card-desc"><strong>Reiniciar</strong>. Borra el contenido del campo Observación para comenzar desde cero.</p>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Si seleccionas varios hallazgos de la lista y pulsas <strong>Registrar</strong>,
        se agregan al campo Observación separados por punto y coma, sin sobrescribir
        lo que ya estaba escrito. Los hallazgos duplicados se omiten automáticamente.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaAnatAten",
  data() {
    return {
      flujo: [
        {
          icon: "table_rows",
          titulo: "Lista de órganos y sistemas",
          desc:   "La tabla muestra todos los órganos y sistemas del paciente con sus observaciones actuales. El sistema los genera automáticamente al crear la atención.",
        },
        {
          icon: "edit",
          titulo: "Editar un registro",
          desc:   "Pulsa el ícono de edición en la fila del órgano o sistema que deseas documentar para abrir el formulario de observaciones.",
        },
        {
          icon: "update",
          titulo: "Actualizar",
          desc:   "Guarda los cambios realizados en la observación del órgano o sistema seleccionado.",
        },
      ],
      campos: [
        {
          icon: "accessibility_new",
          titulo: "Órgano / Sistema",
          desc:   "Nombre del órgano o sistema evaluado. Se muestra junto a su ícono representativo. No es editable.",
        },
        {
          icon: "text_snippet",
          titulo: "Observación",
          desc:   "Campo principal de registro clínico. Acepta texto libre, dictado por voz y hallazgos seleccionados del catálogo. Máximo 250 caracteres.",
        },
      ],
      hallazgos: [
        {
          icon: "checklist",
          titulo: "Lista de hallazgos patológicos",
          desc:   "Catálogo de hallazgos predefinidos para el órgano o sistema seleccionado. Permite seleccionar uno o varios a la vez.",
        },
        {
          icon: "touch_app",
          titulo: "Selección múltiple",
          desc:   "Mantén presionada la tecla Ctrl (Windows) o Cmd (Mac) para seleccionar varios hallazgos al mismo tiempo.",
        },
        {
          icon: "playlist_add",
          titulo: "Botón Registrar",
          desc:   "Agrega los hallazgos seleccionados al campo Observación, separados por punto y coma. Si la observación estaba vacía o decía 'Sin patología', la reemplaza. Los hallazgos ya presentes no se duplican.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>